export { default } from "./Tabs";
export { default as Tab } from "./Tab";
